import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Truck, Mail, Lock, Loader2, ShieldCheck, ChevronRight, ArrowLeft
} from "lucide-react";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "https://bvglinkamazon.com") + "/api";

export const DriverLogin = () => {

    // ====== Inject driver-specific PWA manifest ======
    useEffect(() => {
        // Remove any existing manifest link
        const existingLinks = document.querySelectorAll('link[rel="manifest"]');
        existingLinks.forEach(l => l.remove());

        // Inject driver manifest
        const link = document.createElement('link');
        link.rel = 'manifest';
        link.href = '/manifest-driver.json';
        document.head.appendChild(link);

        // Restore on unmount
        return () => {
            link.remove();
            const restore = document.createElement('link');
            restore.rel = 'manifest';
            restore.href = '/manifest.json';
            document.head.appendChild(restore);
        };
    }, []);
    // =================================================
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ email: "", password: "" });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${API}/drivers/login`, formData);
            if (response.data.success) {
                try {
                    localStorage.setItem("driver_token", response.data.token);
                    localStorage.setItem("driver_data", JSON.stringify(response.data.driver));
                } catch (storageError) {
                    toast.error("Aplikasyon an gen pwoblèm memwa (Storage). Tanpri tcheke anviwònman telefòn ou.");
                }
                toast.success("Byenvini nan Dashboard Chofè ou!");
                navigate("/driver/dashboard");
            }
        } catch (error) {
            console.error("Login Error:", error);
            if (error.response) {
                toast.error(error.response.data?.detail || "Imèl oswa modpas pa kòrèk.");
            } else {
                toast.error("Echèk kominikasyon ak sèvè a. (" + error.message + ")");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center p-4"
            style={{
                background: "linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)",
                fontFamily: "'Inter', sans-serif"
            }}
        >
            {/* Background decorative elements */}
            <div style={{
                position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0
            }}>
                <div style={{
                    position: 'absolute', top: '-15%', right: '-10%',
                    width: '500px', height: '500px', borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(255,153,0,0.08) 0%, transparent 70%)'
                }} />
                <div style={{
                    position: 'absolute', bottom: '-15%', left: '-10%',
                    width: '400px', height: '400px', borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(255,153,0,0.05) 0%, transparent 70%)'
                }} />
            </div>

            <div className="w-full max-w-sm relative z-10">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div style={{
                        width: '76px', height: '76px',
                        background: 'linear-gradient(135deg, #FF9900 0%, #e68a00 100%)',
                        borderRadius: '24px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 16px',
                        boxShadow: '0 20px 50px rgba(255,153,0,0.35)'
                    }}>
                        <Truck style={{ width: '36px', height: '36px', color: '#000' }} />
                    </div>
                    <h1 style={{
                        fontSize: '28px', fontWeight: '900', color: '#fff',
                        letterSpacing: '-1px', fontStyle: 'italic', textTransform: 'uppercase',
                        lineHeight: 1, marginBottom: '6px'
                    }}>
                        BVG<span style={{ color: '#FF9900' }}>LINK</span>
                    </h1>
                    <p style={{
                        fontSize: '9px', fontWeight: '800', color: '#64748b',
                        textTransform: 'uppercase', letterSpacing: '0.2em'
                    }}>Driver Hub</p>
                </div>

                {/* Form Card */}
                <div style={{
                    background: 'rgba(30,41,59,0.8)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '28px',
                    border: '1px solid rgba(255,255,255,0.06)',
                    padding: '28px 24px',
                    boxShadow: '0 40px 80px rgba(0,0,0,0.4)'
                }}>
                    <h2 style={{
                        fontSize: '13px', fontWeight: '900', color: '#fff',
                        textTransform: 'uppercase', letterSpacing: '0.1em',
                        marginBottom: '4px'
                    }}>Konekte kòm chofè</h2>
                    <p style={{
                        fontSize: '11px', color: '#64748b', fontStyle: 'italic', marginBottom: '24px'
                    }}>Antre enfòmasyon ou yo pou kòmanse travay.</p>

                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {/* Email */}
                        <div>
                            <label style={{
                                display: 'block', fontSize: '9px', fontWeight: '800',
                                color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.15em',
                                marginBottom: '8px'
                            }}>Imèl Chofè</label>
                            <div style={{ position: 'relative' }}>
                                <Mail style={{
                                    position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)',
                                    width: '16px', height: '16px', color: '#475569'
                                }} />
                                <input
                                    type="email"
                                    placeholder="chofe@egzanp.com"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    required
                                    style={{
                                        width: '100%', height: '50px', paddingLeft: '42px', paddingRight: '16px',
                                        background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)',
                                        borderRadius: '14px', color: '#fff', fontSize: '14px', fontWeight: '600',
                                        outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = 'rgba(255,153,0,0.5)'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <label style={{
                                display: 'block', fontSize: '9px', fontWeight: '800',
                                color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.15em',
                                marginBottom: '8px'
                            }}>Modpas</label>
                            <div style={{ position: 'relative' }}>
                                <Lock style={{
                                    position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)',
                                    width: '16px', height: '16px', color: '#475569'
                                }} />
                                <input
                                    type="password"
                                    placeholder="••••••••"
                                    value={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                    required
                                    style={{
                                        width: '100%', height: '50px', paddingLeft: '42px', paddingRight: '16px',
                                        background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)',
                                        borderRadius: '14px', color: '#fff', fontSize: '14px', fontWeight: '600',
                                        outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = 'rgba(255,153,0,0.5)'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
                                />
                            </div>
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%', height: '52px', marginTop: '8px',
                                background: loading ? '#64748b' : 'linear-gradient(135deg, #FF9900, #e68a00)',
                                border: 'none', borderRadius: '16px', color: '#000',
                                fontSize: '12px', fontWeight: '900', textTransform: 'uppercase',
                                letterSpacing: '0.1em', cursor: loading ? 'not-allowed' : 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                boxShadow: '0 8px 30px rgba(255,153,0,0.3)',
                                transition: 'all 0.2s', transform: 'scale(1)'
                            }}
                            onMouseEnter={(e) => { if (!loading) e.currentTarget.style.transform = 'scale(1.02)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                        >
                            {loading ? <Loader2 style={{ width: '20px', height: '20px', animation: 'spin 1s linear infinite' }} /> : "KONEKTE KOUNYE A"}
                        </button>
                    </form>

                    {/* Divider */}
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        margin: '24px 0', opacity: 0.3
                    }}>
                        <div style={{ flex: 1, height: '1px', background: '#fff' }} />
                        <span style={{ fontSize: '9px', fontWeight: '800', color: '#fff', textTransform: 'uppercase' }}>oswa</span>
                        <div style={{ flex: 1, height: '1px', background: '#fff' }} />
                    </div>

                    {/* Register link */}
                    <Link to="/driver/register" style={{ textDecoration: 'none' }}>
                        <button style={{
                            width: '100%', height: '46px',
                            background: 'transparent', border: '1px solid rgba(255,153,0,0.3)',
                            borderRadius: '14px', color: '#FF9900',
                            fontSize: '10px', fontWeight: '900', textTransform: 'uppercase',
                            letterSpacing: '0.1em', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                        }}>
                            KREYE YON KONT CHOFÈ <ChevronRight style={{ width: '14px', height: '14px' }} />
                        </button>
                    </Link>
                </div>

                {/* Back link */}
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <Link to="/marketplace" style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        fontSize: '9px', fontWeight: '800', color: '#475569',
                        textTransform: 'uppercase', letterSpacing: '0.15em', textDecoration: 'none'
                    }}>
                        <ArrowLeft style={{ width: '10px', height: '10px' }} /> Tounen nan Marketplace
                    </Link>
                </div>

                {/* Security badge */}
                <div style={{
                    marginTop: '16px', display: 'flex', alignItems: 'center', gap: '10px',
                    padding: '12px 16px', background: 'rgba(255,153,0,0.08)',
                    borderRadius: '14px', border: '1px solid rgba(255,153,0,0.15)'
                }}>
                    <ShieldCheck style={{ width: '16px', height: '16px', color: '#FF9900', flexShrink: 0 }} />
                    <p style={{
                        fontSize: '9px', fontWeight: '800', color: 'rgba(255,255,255,0.6)',
                        textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1.5
                    }}>
                        Espas rezève pou chofè sèlman. <span style={{ color: '#FF9900' }}>Kliyan pa ka antre.</span>
                    </p>
                </div>
            </div>
        </div>
    );
};
